export const environment = {
  production: true,
  // apiUrl: 'http://192.168.100.11/carme/api/', // Prime Care local
  // apiUrl: 'http://103.232.237.202:81/carme/api/', // Prime Care global
  // apiUrl: 'https://primecarehospital.in/carme/api/', // Prime Care global Sub Domain
  // apiUrl: 'http://192.168.100.11/carme/api/', // Mac Care local
  // apiUrl: 'http://103.129.101.146:81/carme/api/', // Mac Care global
  // apiUrl: 'http://219.91.215.4:81/carme/api/', // Mac Care global
  // apiUrl: 'https://epion.maccarehospital.in:499/carme/api/', // Mac Care global Sub Domain
   apiUrl: 'https://epionhealth.in/carme/api/', // Live Server For India
  // apiUrl: 'https://om.epionhealth.in/carme/api/' // Latest Live Server For oman
  // apiUrl: 'https://demo.epionhealth.in:446/carme/api/' // Latest Live Server For demo
  // apiUrl: 'https://test.epionhealth.in/carme/api/' // Latest Testing Server
  // apiUrl: 'http://path.epionhealth.in/carme/api/' // Pathology Server
  // apiUrl: 'http://pharma.epionhealth.in/carme/api/' // Pharmacy Server // Varad Netralaya New
  // apiUrl: 'http://192.168.100.32/carme/api/', // Sobeh local
  // apiUrl: 'http://127.0.0.1/carme/api/', //  local IIS
  // apiUrl: 'http://TalekarServer/carme/api/', //  local Talekar Server
  // apiUrl: 'http://PadwalServer/carme/api/', //  local Padwal Server
  // apiUrl: 'http://SOMANIHOSPITAL/carme/api/', //  local SOMANI HOSPITAL
  // apiUrl: 'http://SHAHAHOSPITAL/carme/api/', //  local SHAHA HOSPITAL
  // apiUrl: 'http://DeshmukhHospital/carme/api/', //  local Deshmukh Hospital
  // apiUrl: 'http://192.168.1.10/carme/api/', // Credence Hospital Mumbai
  // apiUrl: 'http://localhost/carme/api/', // Varad Netralaya Old
  // apiUrl: 'http://APP1/carme/api/', // Vadant Shirur  // Joshi Hospital // Sobeh Computer name // NCA local // Gunjal Local // Apex // MacCare APP1
  // apiUrl: 'http://APP2/carme/api/', // MacCare APP2 Server
  // apiUrl: 'http://ACC1/carme/api/', // MacCare ACC1 Server
  // apiUrl: 'https://epion.nisargopacharashram.org/carme/api/', // NCA  global By sub Domain
  // apiUrl: 'http://43.241.26.83:81/carme/api/', // Vedanta Static IP
  // apiUrl: 'https://nca.epionhealth.in/carme/api/' // NCA
  // apiUrl: 'http://45.252.73.20:81/carme/api/', // NCA global By Static IP
  // apiUrl: 'http://MATOSHRI/carme/api/' // Bhosale Hospital Shrigonda
  // apiUrl: 'http://APP2/carme/api/' // Sidhivinayak Hospital Server  // P - vinayak@1
  // apiUrl: 'http://Vighnaharta/carme/api/' // Vighnaharta Hospital
  // apiUrl: 'http://Helike/carme/api/' // My Computer
  // apiUrl: 'http://192.168.100.30/carme/api/', // Sobeh local other Testing Server
  // apiUrl: 'http://103.129.101.2:81/carme/api/', // Gunjal Global
  // apiUrl: 'http://SINOPE/carme/api/', // Office local
  // apiUrl: 'http://103.81.39.13:81/carme/api/', // Swaroop Hospital Shirur
  // apiUrl: 'http://anb.epionhealth.in/carme/api/', // Anbhule Hospital
  // apiUrl: 'http://192.168.0.7:81/carme/api/', // NCA 
  // apiUrl: 'http://SujanHospital/carme/api/', // Arora Hospital
  // ng build --aot --watch --configuration --outputHashing=all
};
